import { Activity } from 'lucide-react'

interface BrandMarkProps {
  compact?: boolean
}

export function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <div className={compact ? 'brand-mark brand-mark--compact' : 'brand-mark'} aria-label="Medical Horizon">
      <span className="brand-mark__seal" aria-hidden="true">
        <Activity size={18} strokeWidth={2.5} />
      </span>
      <span className="brand-mark__copy">
        <strong>medical horizon</strong>
        <small>عملي الجراحة</small>
      </span>
    </div>
  )
}
